import React from 'react';
import Input from '../Modules/Input';
import * as util from './../Scripts/General.js';
import './Style.css';

export default function ContactUs() {
    const [submitClicked, setSubmitClicked] = React.useState();
    const [generalMessage, setGeneralMessage] = React.useState('');
    const [buttonText, setButtonText] = React.useState('Send');
    const [formKey, setFormKey] = React.useState(0);
    
    const [fields, setFields] = React.useState({
        txtName: { type: 'text', placeholder: 'Name', maxLength: 50, value: '', onChange: handleChange, error: '' },
        txtEmail: { type: 'text', placeholder: 'E-mail', maxLength: 100, value: '', onChange: handleChange, error: '' },
        txtSubject: { type: 'text', placeholder: 'Subject', maxLength: 100, value: '', onChange: handleChange, error: '' },
        txtMessage: { type: 'textarea', placeholder: 'Message', maxLength: 5000, value: '', onChange: handleChange, error: '' }
    });
    function handleChange(name, value) {
        setFields((oldFields) => {
            oldFields[name].value = value;
            return oldFields;
        });
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        setGeneralMessage('');
        if (buttonText === 'Send') {
            setSubmitClicked(true);
            setFields((oldFields) => {
                oldFields.txtName.error = oldFields.txtName.value === '' ? 'Required!' : '';
                oldFields.txtSubject.error = oldFields.txtSubject.value === '' ? 'Required!' : '';
                oldFields.txtMessage.error = oldFields.txtMessage.value === '' ? 'Required!' : '';
                if (oldFields.txtEmail.value === '')
                    oldFields.txtEmail.error = 'Required!';
                else if (!util.IsEmail(oldFields.txtEmail.value))
                    oldFields.txtEmail.error = 'Email address is invalid';
                else
                    oldFields.txtEmail.error = '';
                return { ...oldFields };
            });
        } else {
            setButtonText('Send');
            setFormKey((old) => old + 1); //Resetform
            setFields((oldFields) => {
                oldFields.txtName.value = '';
                oldFields.txtEmail.value = '';
                oldFields.txtSubject.value = '';
                oldFields.txtMessage.value = '';
                return { ...oldFields };
            });
        }
    }
    React.useEffect(() => {
        document.title = 'Contact us';
    }, []);
    React.useEffect(() => {
        if (submitClicked) {
            let error = '';
            for (const [key, value] of Object.entries(fields))
                error += value.error;
            if (error === '')
                SendContactUsEmail();
            setSubmitClicked(false);
        }
    }, [fields])
    return (
        <div className="contactUs">
            <div className="main">
                For further information, Feel free to contact us by using the form below:
                <form className="form" onSubmit={handleSubmit} key={formKey}>
                    <Input name="txtName" attribs={fields.txtName} />
                    <div className="name error">{fields.txtName.error}</div>
                    <Input name="txtEmail" attribs={fields.txtEmail} />
                    <div className="email error">{fields.txtEmail.error}</div>
                    <Input name="txtSubject" attribs={fields.txtSubject} />
                    <div className="subject error">{fields.txtSubject.error}</div>
                    <Input name="txtMessage" attribs={fields.txtMessage} />
                    <div className="message error">{fields.txtMessage.error}</div>
                    <div><button className="btnSend">{buttonText}</button></div>
                    <div className="general error">{generalMessage}</div>
                </form>
            </div>
        </div>
    );
    function SendContactUsEmail() {
        util.Fetch('SendContactUsEmail',
            {
                name: fields.txtName.value,
                email: fields.txtEmail.value,
                subject: fields.txtSubject.value,
                message: fields.txtMessage.value
            })
            .then(json => {
                setGeneralMessage('Your comment has been sent successfully.');
                setButtonText('New');
            })
            .catch(error => {
                setGeneralMessage('Please check your internet connection or try again later.');
            });
    }
}